// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Selector$SmartcutsMacros = require("../Selector.bs.js");

function MakePlaybackParamValue(ParamDescriptor, PlaybackCommandValue) {
  var t_encode = Decco.stringToJson;
  var t_decode = Decco.stringFromJson;
  var fromParamDescriptor = function (param) {
    return param.defaultValue;
  };
  var toCommandValueForPlayback = function (oldCommandValue, value) {
    return Curry._2(PlaybackCommandValue.updateSelector, (function (param) {
                  return Selector$SmartcutsMacros.updateLeafNode((function (node) {
                                return {
                                        id: node.id,
                                        tagName: node.tagName,
                                        classNames: node.classNames,
                                        attributes: node.attributes,
                                        index: node.index,
                                        innerText: {
                                          TAG: /* FullInnerText */0,
                                          _0: value
                                        },
                                        isScrollable: node.isScrollable,
                                        attributeBlacklist: node.attributeBlacklist
                                      };
                              }), param);
                }), oldCommandValue);
  };
  return {
          t_encode: t_encode,
          t_decode: t_decode,
          fromParamDescriptor: fromParamDescriptor,
          toCommandValueForPlayback: toCommandValueForPlayback
        };
}

exports.MakePlaybackParamValue = MakePlaybackParamValue;
/* Selector-SmartcutsMacros Not a pure module */
